<template>
    <div class="intell-answer">
        <div class="answer-info">
            <div class="answer-banner" v-if="list.length==0">
                <h2 class="banner-tit">
                    <img src="../../assets/images/ai.png" width="40px" height="40px" alt="">
                    你好! 欢迎使用中医养生助手
                </h2>
                <p>基于多模态数据、大模型及推理技术，整合中医药养生知识，为您推荐个性化的健康干预措施。</p>
            </div>
            <div v-else class="info-list" id="info-list">
                <div
                    v-for="(item, index) in list" 
                    class="list"
                    :key="index"
                    > 
                    <!-- 1.用户内容 --> 
                    <div v-if="index%2===0"  class="list-user">
                        <div class="cont">
                            <div class="txt">{{item.val}}</div>
                            <p>{{item.timer}}</p>
                        </div>
                        <div class="icon"></div> 
                    </div> 
                    <!-- 2.回答头像 --> 
                    <div v-else  class="list-answer">
                        <div class="icon"></div>
                        <div class="cont">
                            <div class="txt" v-if="index==list.length-1&&isAnswer&&!item.val">
                                <i class="el-icon-loading"></i> 思索中，请您耐心等待......
                            </div>
                            <div class="txt" v-else>
                                <VueMarkdown :source="item.val" ></VueMarkdown>
                                <span v-if="item.isStreaming" class="streaming-loading">
                                    <i class="el-icon-loading"></i>
                                </span>
                            </div>
                            <p>{{item.timer}}</p>
                        </div>

                    </div>
                </div> 
            </div>
            <div class="recorded">
                <!-- @keydown.enter.native="send" -->
                <el-input type='textarea' v-model="question" :rows="3"  :cols="4"  class="problem"  placeholder="请输入您的问题，[Ctrl+Enter]换行，[enter]发送" @keydown.native="handleKeyCode($event)"></el-input>
                <div  class="send" >
                    <el-button v-if="list.length>0" :disabled="isAnswer" type="success" @click="refresh_clcik" >新对话</el-button>
                    <el-button type="primary" @click="send" :disabled="isAnswer">发送</el-button>
                </div>
            </div> 
        </div>
    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import {getRandomId,questionsAnswers} from '../../io/api.js'
import formDates from '../../utils/formDate.js' 
import {getRealTime} from '../../utils/getRealTime.js'
export default {
    components: {VueMarkdown},
    data() {
        return {
            list:[],
            question:'',
            isAnswer:false,
            chatId:'',
        }
    },
    watch: {},
    mounted() {
        this.getChatId();
    },
    methods: {
        handleKeyCode(e){
            if (e.keyCode == 13) {
                if (!e.ctrlKey) {
                    this.send()
                    e.preventDefault()
                } else {
                    this.question += "\n";
                }
            }
        },
        getChatId(){
            getRandomId().then(res=>{
                let data = res.data;  
                if(data.code==0){
                    this.chatId=data.data.chatId||'';
                }else{
                    this.$message.error(data.msg||'请求失败～');
                }
            })
        },
        send(){ 
            if (this.isAnswer) return
            if(this.question==''){
                this.$message.error('请输入您的问题～');
                return
            }
            this.isAnswer=true;   
            let arr=[
                {
                    val:this.question,
                    timer:getRealTime(),
                },
                {
                    val:'',
                    timer:'',
                    isStreaming: false, // 标记是否正在流式输出
                }
            ]
            if(this.list.length==0){
                this.list=arr;
            }else{
                this.list=[...this.list,...arr];
            }
            this.scrollToBottom();
            
            // 流式接收答案
            const answerIndex = this.list.length - 1;
            let fullAnswer = '';
            let params = { 
                type: "2",
                questions: this.question,
                chatId:this.chatId,
            }
            // 设置流式输出状态
            this.$set(this.list[answerIndex], 'isStreaming', true);
            questionsAnswers(
                params,
                // onMessage: 接收到流式数据
                (data) => { 
                    // 根据后端返回的数据结构解析内容
                    let chunk = '';
                    // 优先处理 OpenAI 风格的流式响应格式
                    // 格式: {choices: [{delta: {content: "..."}}]}
                    if (data.choices && Array.isArray(data.choices) && data.choices.length > 0) {
                        const choice = data.choices[0];
                        if (choice.delta && choice.delta.content !== undefined) {
                            // 获取增量内容（可能是字符串或空字符串）
                            chunk = choice.delta.content || ''; 
                            if (chunk) {
                                fullAnswer += chunk;
                            }
                        }
                    } 
                    // 实时更新显示（只要有内容更新就刷新）
                    if (chunk !== undefined) { 
                        // 使用 Vue.set 确保响应式更新
                        this.$set(this.list[answerIndex], 'val', fullAnswer);
                        // 保持流式输出状态
                        this.$set(this.list[answerIndex], 'isStreaming', true);
                        // 强制触发视图更新
                        this.$nextTick(() => {
                            this.scrollToBottom();
                        });
                    }
                },
                // onError: 错误处理
                (error) => {
                    this.isAnswer = false;
                    // 移除流式输出状态
                    this.$set(this.list[answerIndex], 'timer', getRealTime());
                    this.$set(this.list[answerIndex], 'isStreaming', false);
                    this.$set(this.list[answerIndex], 'val', '请求失败，请稍后重试～');
                    console.error('流式请求错误:', error);
                    this.$message.error('请求失败，请稍后重试～');
                    // 如果出错，移除空的答案项
                    if (!this.list[answerIndex].val) {
                        this.list.splice(answerIndex, 1);
                    }
                },
                // onComplete: 完成处理
                () => {
                    this.isAnswer = false;
                    // 移除流式输出状态
                    this.$set(this.list[answerIndex], 'isStreaming', false);
                    // 确保最终答案已更新
                    if (fullAnswer) {
                        this.$set(this.list[answerIndex], 'timer', getRealTime());
                        this.$set(this.list[answerIndex], 'val', fullAnswer);
                    }
                    this.$nextTick(() => {
                        this.scrollToBottom();
                    });
                }
            );
            
            this.question='';
            // this.scrollToBottom();
            // getHealthAi({content:this.question}).then(res=>{
            //     let data = res.data;  
            //     if(data.code==0){
            //         this.isAnswer=false;
            //         this.list[this.list.length-1].val=data.data.replyResult||''; 
            //         this.scrollToBottom();
                    
            //     }else{
            //         this.$message.error(data.msg||'请求失败～');
            //     }
            // })
            // this.question='';
 
        }, 
        refresh_clcik(){
            this.getChatId();
            this.list=[];
            this.question='';
            this.isAnswer=false;
        },
        // 定义将滚动条定位在底部的方法
        scrollToBottom(){
            this.$nextTick(()=>{
            let info = this.$el.querySelector("#info-list")
                info.scrollTop = info.scrollHeight
            })
        },
         // 时间转换
        formDate(date, day = "yyyy-MM-dd h:m:s") {
            return formDates(date, day)
        },
    }
}
</script>
<style lang='less' scoped>
.intell-answer{
    width: 1000px;
    margin: 50px auto;
    .answer-info{
        min-height: 600px;
    }
    .answer-banner{
        width: 100%;
        padding:80px 50px; 
        /* background: url(../images/tit-bg1.jpg) no-repeat; */
        background-size: cover;
        text-align: center;
        color: #000000;
        line-height: 40px;
        .banner-tit{
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            img{
                margin-right:10px
            }
        }
        p{ 
            line-height: 40px;
        }
    }
        .info-list{ 
            height: 430px;
            overflow-y: auto;
            padding:20px; 
            /* padding-right: 2%; */
            font-size: 14px; 
            .list {
                position: relative;
                margin-bottom: 20px;
                >div{
                    width:750px ;
                }
                .icon{
                    flex-shrink: 0;
                    display: inline-block;
                    width: 34px;
                    height: 34px;
                    
                }
                .cont{
                    // max-width: 700px;
                    .txt{
                        border-radius: 6px; 
                        padding: 10px;
                        margin-bottom: 8px; 
                        line-height: 24px;
                        display: inline-block;
                        position: relative;
                        .streaming-loading{
                            display: inline-block;
                            margin-left: 4px;
                            vertical-align: middle;
                            i{
                                animation: rotating 1s linear infinite;
                            }
                        }
                    }
                }
                 
            }
            .list-answer{
                display: flex; 
                .icon{
                    flex-shrink: 0;
                    margin-right: 10px;
                   background: url('../../assets/images/ai.png') no-repeat;
                   background-size: 100%;
                }
                .txt{ 
                    background: #ececec;
                }
            }
            .list-user{ 
                margin-left: auto; 
                display: flex;
                justify-content: flex-end;
                // p{
                //     text-align: right;
                // }
                .cont{
                    text-align: right;
                }
                .icon{
                    margin-left: 10px;
                    background: url('../../assets/images/user.png') no-repeat;
                    background-size: 100%;
                }
                .txt{ 
                    background: #396de7;
                    color: #fff;
                }
            }
        } 
    .recorded {
        padding: 20px 0px 10px;
        position: relative; 
        .problem {
            // height: 68px;
            // width: 100%; 
            padding: 10px;
            font-size: 14px;
            outline: none;
            border-color: #396de7;
            border-radius: 6px;
            ::v-deep .el-textarea__inner {  
                resize: none;  
            }
        }
        .send {
            margin-left: auto; 
            margin-right: 10px;   
            text-align: right;
            color: #fff;
            // cursor: pointer;
        }
    }
}
@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>